import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import _ from 'underscore';

const prepareClinicTypeOptions = (list) => {
    return _.map(list, ({value, text}) => {
        return { text, value };
    })
};

const ClinicListFilterByType = (props) => {
    const clinicTypeOptions = prepareClinicTypeOptions(props.typeList);
    const updateFilterOptions = (e, { value}) => {
        props.updateClinicFilterOptions({filterByType: value});
        props.updateMode(3, null);
    }
    return (
        <Dropdown 
            placeholder='Select Clinic Type' 
            onChange={updateFilterOptions}
            fluid 
            selection 
            options={clinicTypeOptions} 
            value={props.filterOptions.filterByType}
        />
    );
}

export default ClinicListFilterByType;